import React from 'react';
import { useSelector } from 'react-redux';
import { get } from 'lodash-es';
import Global from '../../../store/global-selectors';
import { IncludeReturnLabel } from './inputs/include-return-label';
import { PackageService } from '../../../services/package-service';
import { useFulfillmentPlannerContext } from '../../../fulfillment-planner/context';

const IncludeReturnLabelContainerComponent = (props) => {
  const packages = useSelector((state) => Global.selectSellerPackages(state)) || [];

  const { packages: CSWselectedPackages, serviceIdAndSellerLabelProviderId, isInternational } = useFulfillmentPlannerContext();
  const CSWselectedServiceId = serviceIdAndSellerLabelProviderId?.serviceId;

  const defaultReturnPackageTypeArray = useSelector((state) => {
    return (
      Global.selectSellerSellerSetting(state, {
        settingName: 'ReturnPackage',
      })?.split('-') || []
    );
  });
  const defaultReturnPackageTypeId = defaultReturnPackageTypeArray.length ? defaultReturnPackageTypeArray[0] : undefined;

  const defaultReturnServiceId = useSelector((state) => Global.selectSellerSellerSetting(state, { settingName: 'ReturnService' }));

  const selectedPackageTypeId = get(props, 'optionData.packageTypeId');
  // As we do not support multipackage returns, we use the one selected package, or below will default to the "Standard Package"
  const CSWselectedPackageTypeId = CSWselectedPackages?.length === 1 ? get(CSWselectedPackages[0], 'packageTypeId') : null;
  const packageTypeId =
    selectedPackageTypeId || defaultReturnPackageTypeId || CSWselectedPackageTypeId || PackageService.getStandardPackageId();

  const optionData = get(props, 'optionData');

  const otherOptionsSelectedServiceId = get(optionData, 'serviceId');
  const serviceId = otherOptionsSelectedServiceId || defaultReturnServiceId || CSWselectedServiceId;

  const calculatedOptionData = {
    serviceId,
    packageTypeId,
    labelProviderId: optionData?.labelProviderId,
  };
  const service = useSelector((state) => Global.selectSellerServiceById(state, { serviceId }));
  if (!get(optionData, 'labelProviderId')) {
    const labelProviderId = get(service, 'labelProviderId');
    calculatedOptionData.labelProviderId = labelProviderId;
  }

  return (
    <IncludeReturnLabel
      {...props}
      isInternational={isInternational}
      optionData={calculatedOptionData}
      selectedPackage={PackageService.findBestGuessPackageByPackageTypeId(packageTypeId, packages)}
    />
  );
};

export const IncludeReturnLabelContainer = React.memo(IncludeReturnLabelContainerComponent);
